<template functional>
  <ASubMenu :key="props.menuInfo.id">
    <MenuContent slot="title" :item="props.menuInfo" :is-collapsed="props.isCollapsed" />
    <template v-for="item in props.menuInfo.subMenu">
      <BasicMenuItem v-if="!item.subMenu" :key="item.id" :item="item" :is-collapsed="props.isCollapsed" />
      <SubMenu v-else :key="item.id" :menu-info="item" />
    </template>
  </ASubMenu>
</template>

<script>
import BasicMenuItem from './basic-menu-item'
import MenuContent from './menu-content'

export default {
  name: 'SubMenu',

  components: {
    BasicMenuItem,
    MenuContent,
  },

  props: {
    menuInfo: {
      type: Object,
      default: () => ({}),
    },
    isCollapsed: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
